(function( $ ) { //alert("aaaa");
   "use strict";
   var body = $('body'),
       $document = $(document),
      page_type = T4Srequest.page_type,
      cartTypeIsDisable = (T4Sconfigs.cartType == 'disable'),
      strCartDataMini = cartTypeIsDisable ? 'cart_data' : 'cart_data,mini_cart',
      sections_nt = (page_type != 'cart') ? strCartDataMini : `cart_data,${window.cartT4SectionID}`, 
      sections_ntArray = (sections_nt).split(',');

   body.on('click', 'button.single_add_to_cart_buttn', function(e){
        e.preventDefault();
        $('.cl-cart-validate').click();
        $(".cl-po--popup-close").css("display","none");
        $(this).addClass('is--loading');
        
        _learnq.push(['track', 'Added to Cart', item]); // for Klaviyo
        //var formid = $('#cart-form_ppr');
      var formId = $(".t4s-form__product");
     findProgress(formId);
    });

    $(document).on('click', '.mfp-close, .t4s-painting-popup-close', function() {
        $('.t4s-personalization-popup-wrapper, .t4s-personalization-popup')
            .removeClass('mfp-ready')
            .addClass('mfp-hide');
    });
  
    function findProgress(formID){
      let progress_interval = setInterval(function(){
          console.log("checking for progress");
          if($('.options-atc .cl-po--preview-progress').length <= 0){
            var window_url = window.location.pathname;
            if(!window_url.includes('gift-set')){
              $('.cl-cart-validate').click();
              setTimeout(() => {
                addItemFrom(formID);
              }, 1000);
              setTimeout(() => {
                 $(".cl-po--popup-close").css("display","block");
                $('.cl-po--popup-close').trigger('click');
                $('button.single_add_to_cart_buttn').removeClass('is--loading');
                $('body').removeClass('no-scrolling');
              }, 2000);
            }
            console.log('no progressbar - add products');
            
            clearInterval(progress_interval);
          }
        }, 500);
    }

    /*!
     * Serialize all form data into a SearchParams string
     * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}   form The form to serialize
     * @return {String}      The serialized form data
     */
    function serializet4(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
       return arr;
      //return arr.join('&');
    };

   function addItemFrom(form_id) {
      var  cartAddUrl = T4Sroutes.cart_add_url + '.js';

     var data = serializet4(form_id[0]);
     const personalizationType = $('.cl-po--option')
          .find('input[name="properties[personalization_type]"]:checked')
          .val() || '';
    console.log(personalizationType)
     data.push(
          encodeURIComponent('sections') + '=' + encodeURIComponent(sections_ntArray)
      );
     data.push(
          encodeURIComponent('sections_url') + '=' + encodeURIComponent(window.location.pathname)
      );
     
      fetch(cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            //body: serializet4(form_id[0])
           body: data.join('&')
      })
     .then(function(response) {
          return response.json();
      })
     .then(function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.description);
                 $document.trigger('cart:updated');
                 return;
              }
          $document.trigger('add:cart:success').trigger('add:cart:upsell');
          T4SThemeSP.isATCSuccess = true;
          T4SThemeSP.Cart.renderContents(response.sections);
          if (personalizationType === "Painting") {
              $('.t4s-personalization-popup-wrapper, .t4s-personalization-popup')
                  .removeClass('mfp-hide')
                  .addClass('mfp-ready');
          }
     })
     .catch(function(error) {
        $document.trigger('cart:updated');
        console.log(error);
     });
   } 
    function handleErrorMessage(message) {
      $("button.single_add_to_cart_button").after(
        `<p class="cart-error">${message}</p>`
      );
    }

})( jQuery_T4NT );